import React from "react";

import { Badge, countLabel, Heading, Text } from "@/components/ui";
import type { ProgrammeGovernanceSummary } from "@/platform";

export interface LegacyAmendmentProposalsProps {
  governance: ProgrammeGovernanceSummary;
}

export function LegacyAmendmentProposals({
  governance,
}: LegacyAmendmentProposalsProps): React.ReactElement | null {
  if (governance.amendmentProposals.length === 0) {
    return null;
  }

  return (
    <section className="mt-4" data-testid="legacy-amendment-proposals">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <Heading level={3} size="md">
            Earlier amendment proposals
          </Heading>
          <Text tone="muted" className="mt-1">
            {countLabel(governance.amendmentProposals.length, "proposal")} recorded.
          </Text>
        </div>
        <Badge variant="outline">Historical</Badge>
      </div>
      <ul className="mt-3 space-y-2 text-md" data-testid="amendment-proposals">
        {governance.amendmentProposals.map((proposal) => (
          <li key={proposal.id} className="flex flex-wrap items-center gap-2">
            <Badge size="sm" variant="outline">
              {proposal.classification}
            </Badge>
            <span className="font-medium">{proposal.title}</span>
            <span className="text-muted">{proposal.status}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
